import { FC, useMemo, useState, MouseEvent, } from "react";
// 组件
import { CloseOutlined, DownOutlined, LoadingOutlined, } from "@ant-design/icons";
// 常量
import { SelectTabInputBaseProps } from "../../interface";

interface SelectInputProps extends SelectTabInputBaseProps {
  
}

const SelectInput: FC<SelectInputProps> = props => {
  const { placeholder, loading, value, disabled, allowClear, onClear, } = props;
  const [isInputClose, setIsInputClose] = useState<boolean>(false);
  const [isIconClose, setIsIconClose] = useState<boolean>(false);
  /** 清除选中 */
  const handleClear = (event: MouseEvent<HTMLSpanElement>) => {
    event.stopPropagation();
    onClear?.();
  };
  /** 鼠标指针移出Input */
  const handleInputMouseLeave = () => {
    if (disabled) return;
    setIsInputClose(false);
  };
  /** 鼠标指针移入Input */
  const handleInputMouseEnter = () => {
    if (disabled) return;
    setIsInputClose(true);
  };
  /** 鼠标指针移出Icon */
  const handleIconMouseLeave = () => {
    if (disabled) return;
    setIsIconClose(false);
  };
  /** 鼠标指针移入Icon */
  const handleIconMouseEnter = () => {
    if (disabled) return;
    setIsIconClose(true);
  };
  const renderIconHtml = useMemo(() => {
    if (loading) {
      return <LoadingOutlined />;
    }
    if (allowClear && (isInputClose || isIconClose) && value) {
      return (
        <CloseOutlined
          className="yb-select-input-close"
          onClick={handleClear}
        />
      )
    }
    return <DownOutlined className="yb-select-input-icon" />;
  }, [loading, isInputClose, isIconClose, value]);
  return (
    <div className="yb-select-tab-container">
      <div
        className="yb-select-tab-container-input"
        onMouseLeave={handleInputMouseLeave}
        onMouseEnter={handleInputMouseEnter}
      ></div>
      <div className="yb-select-tab-container-prefix">
        {
          !value && (
            <span className="yb-line-ellipsis-1">{placeholder}</span>
          )
        }
      </div>
      <div
        className="yb-select-tab-container-suffix"
        onMouseLeave={handleIconMouseLeave}
        onMouseEnter={handleIconMouseEnter}
      >
        {renderIconHtml}
      </div>
    </div>
  );
};

export default SelectInput;
